type ThemeMode = "auto" | "light" | "dark";

const STORAGE_KEY = "theme";
const DARK_MQ = window.matchMedia("(prefers-color-scheme: dark)");

function effectiveTheme(mode: ThemeMode): "light" | "dark" {
  return mode === "auto" ? (DARK_MQ.matches ? "dark" : "light") : mode;
}

function applyTheme(mode: ThemeMode) {
  const effective = effectiveTheme(mode);
  document.documentElement.classList.toggle("dark", effective === "dark");
}

export function getThemeMode(): ThemeMode {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === "light" || saved === "dark") return saved;
  return "auto";
}

export function setThemeMode(mode: ThemeMode) {
  if (mode === "auto") {
    localStorage.removeItem(STORAGE_KEY);
  } else {
    localStorage.setItem(STORAGE_KEY, mode);
  }
  applyTheme(mode);
}

export function cycleTheme(): ThemeMode {
  const order: ThemeMode[] = ["auto", "light", "dark"];
  const next = order[(order.indexOf(getThemeMode()) + 1) % order.length];
  setThemeMode(next);
  return next;
}

export function initTheme() {
  const mode = getThemeMode();
  applyTheme(mode);
  DARK_MQ.addEventListener("change", () => applyTheme(getThemeMode()));
}

export function themeIcon(mode: ThemeMode): string {
  switch (mode) {
    case "auto":
      return "\u{1F317}";
    case "light":
      return "\u2600\uFE0F";
    case "dark":
      return "\u{1F319}";
  }
}

export function themeLabel(mode: ThemeMode): string {
  switch (mode) {
    case "auto":
      return "Auto (system)";
    case "light":
      return "Light";
    case "dark":
      return "Dark";
  }
}
